// extracted by mini-css-extract-plugin
export var container = "styles-module__container___IfEJM";
export var dividerBars = "styles-module__dividerBars___MsUQn";
export var titleContainer = "styles-module__titleContainer___miuzM";
export var plusBadge = "styles-module__plusBadge___nGxhh";
export var title = "styles-module__title___XntBn";
export var body = "styles-module__body___t_M9P";
export var truncate = "styles-module__truncate___mTVZn";
export var showMore = "styles-module__showMore___QMkQh";